import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_ARc9841kP',
      userPoolClientId: '1kkju55infakcnmotl298tvos3',
      loginWith: {
        oauth: {
          domain: 'logintest.tailor.wf',
          scopes: [
            'phone',
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: ['https://test.tailor.wf/'],
          redirectSignOut: ['https://test.tailor.wf/'],
          responseType: 'code',
        },
      },
    },
  },
};
export default amplifyConfig;
